import { setUser } from '@sentry/react';

import { ILoginResponse } from '@src/api/types/auth.types';
import {
  queryClient,
  queryClientDefaultOptions,
} from '@src/configs/tanstack.configs';
import { QUERY_KEYS, STORAGE_KEY } from '@src/constants';

import { removeToken, setToken } from './axios.helpers';

export const authLogoutUtils = async () => {
  removeToken();
  setUser(null);
  queryClient.resetQueries({ queryKey: [QUERY_KEYS.token] });

  const isAuthenticated = queryClient.getQueryData([QUERY_KEYS.authUserInfo]);

  if (isAuthenticated) {
    await queryClient.resetQueries({ queryKey: [QUERY_KEYS.subscriptionsMe] });
    await queryClient.resetQueries({ queryKey: [QUERY_KEYS.authUserInfo] });
    queryClient.setDefaultOptions({
      ...queryClientDefaultOptions,
      queries: {
        ...queryClientDefaultOptions.queries,
        enabled: false,
      },
    });
  }
};

export const authLoginUtils = async (data?: ILoginResponse) => {
  const { user, token } = data || {};

  if (!user || !token) return;

  await queryClient.setQueryData([QUERY_KEYS.authUserInfo], user);
  queryClient.setDefaultOptions({
    ...queryClientDefaultOptions,
    queries: {
      ...queryClientDefaultOptions.queries,
      enabled: true,
    },
  });

  if (user.is_registration_completed) localStorage.removeItem(STORAGE_KEY.DATA);

  setToken(token);
  await queryClient.refetchQueries({ queryKey: [QUERY_KEYS.token] });

  setUser(user);
};
